"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const theme_1 = __importDefault(require("../../styles/theme"));
const icon_1 = __importDefault(require("../icon/icon"));
const ussdBankListStyles_1 = __importDefault(require("./ussdBankListStyles"));
const banks_1 = __importDefault(require("../../utils/banks"));
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const text_1 = __importStar(require("../text/text"));
const styles_1 = __importDefault(require("../../styles/styles"));
const logoLendigo = require('../../assets/images/logo.png');
const UssdBankList = ({ ussdBankAccountList }) => {
    const callBank = (bankCall) => {
        const dialedPhoneNumber = `tel:${bankCall.format}`;
        react_native_1.Linking.canOpenURL(dialedPhoneNumber).then((supported) => {
            if (supported) {
                react_native_1.Linking.openURL(dialedPhoneNumber);
            }
        });
    };
    const getBankLogo = (bankValue) => {
        const logo = banks_1.default.find((bank) => bank.value === bankValue);
        if (logo === undefined) {
            return logoLendigo;
        }
        return logo.image;
    };
    return (react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: true, style: ussdBankListStyles_1.default.listSize }, ussdBankAccountList.map((bank) => (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow] },
        react_1.default.createElement(react_native_1.View, { style: [ussdBankListStyles_1.default.smallFlex] },
            react_1.default.createElement(react_native_paper_1.Avatar.Image, { style: ussdBankListStyles_1.default.bankLogo, source: getBankLogo(bank.value), size: 50 })),
        react_1.default.createElement(touchableElement_1.default, { onPress: () => callBank(bank), style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow], eventName: "loanPaymentMethod_ussd_callBank" },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, subtitleExtraText: bank.format }, bank.name))),
        react_1.default.createElement(touchableElement_1.default, { onPress: () => callBank(bank), style: ussdBankListStyles_1.default.smallFlex, eventName: "loanPaymentMethod_ussd_callBank" },
            react_1.default.createElement(react_native_1.View, { style: [ussdBankListStyles_1.default.smallFlex, ussdBankListStyles_1.default.smallTopMargin] },
                react_1.default.createElement(icon_1.default, { name: "faPhone", fill: theme_1.default.colors.COLOR_PRIMARY }))))))));
};
exports.default = UssdBankList;
